import React, { useEffect, useState } from "react";
import "./layout.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLayoutWraper } from "../slices/LayoutSlice";
import Alert from "../components/alert/Alert";
import { redirectUrl } from "../constants/Api";
import { Helmet } from "react-helmet";

function AppLayout({ children }) {
  const location = useLocation();

  const pathname = location.pathname;
  console.log(pathname);
  const restrictHotelListFlag = localStorage.getItem('restrictHotelListFlag');
  useEffect(()=>{
    if(restrictHotelListFlag == 1){
      console.log("yes")
      if(pathname == "/"){
      navigate('/hotel-list')}
    }
  },[restrictHotelListFlag])
  
  const [layout, setLayout] = useState(false);
  const [prevPath, setPrevPath] = useState(null);
 
  const [showAlert, setShowAlert] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const checkEndPoints = () => {
    if (
      pathname.includes("/hotel-detail") ||
      pathname.includes("/event-details") ||
      pathname === "/"
    ) {
      setLayout(true);
      console.log("expolore");
      dispatch(setLayoutWraper(true));
    } else {
      setLayout(false);
       dispatch(setLayoutWraper(false));
    }
  };

  const backToHotels = () => {
    localStorage.removeItem("restrictHotelListFlag");
    localStorage.removeItem("restrictHomePageFlag");
    setShowAlert(false);
    navigate("../hotel-list");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    checkEndPoints();
    setTimeout(() => {
      setPrevPath(pathname);
    }, 10);
  }, [pathname]);
 

  useEffect(() => {
    const handlePopState = () => {
      if (prevPath == "/home") {
        setShowAlert(true);
      }else if(prevPath=='/tickets'){
        // console.log(prevPath)
        window.location.href = redirectUrl
        // alert("hi")
      }
    };
    if (pathname == "/home" || prevPath == "/tickets" ) {
      window.addEventListener("popstate", handlePopState());
    }
  }, [pathname]);

  return (
    <div>
       <Helmet>
        <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
        <meta http-equiv="Pragma" content="no-cache" />
        <meta http-equiv="Expires" content="0" />
      </Helmet>
      <div className={layout ? "" : "app-wrapper"}>{children}</div>
      {showAlert && (
        <Alert
          closeHotel={backToHotels}
          hideModal={() => {
            setShowAlert(false); 
          }}
        />
      )}
    </div>
  );
}

export default AppLayout;
